import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

const scaleIn = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } }
};

export const ProductVisualSection = () => {
  return (
    <section className="py-24 bg-[#F9F9FA]" data-testid="product-visual-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} className="text-center mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-[#29282B] mb-4">
            Une interface pensée pour l'éducation
          </h2>
          <p className="text-[#29282B]/70 text-lg max-w-2xl mx-auto">
            Placement intelligent, badges élèves à besoins particuliers (EBP), légendes couleurs... Tout pour faciliter votre quotidien.
          </p>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={scaleIn} className="animate-float">
          <div className="macbook-frame max-w-4xl mx-auto">
            <div className="macbook-screen aspect-[16/10]">
              <img 
                src="/eduplan-screens/editeur de plan de classe vie-scolaire.png" 
                alt="EduPlan - Éditeur de plan de classe" 
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="macbook-base max-w-4xl mx-auto" />
        </motion.div>
      </div>
    </section>
  );
};

export const ScreenshotsSection = () => {
  const screenshots = [
    {
      title: "Dashboard Vie Scolaire",
      description: "Vue d'ensemble de votre établissement : élèves, professeurs, salles et plans de classe.",
      image: "/eduplan-screens/daschboard vie-scolaire.png"
    },
    {
      title: "Gestion des Élèves EBP",
      description: "Identifiez et gérez les besoins particuliers de chaque élève (PAP, TSA, vue, audition...).",
      image: "/eduplan-screens/ebp vie-scolaire.png"
    },
    {
      title: "Dashboard Professeur",
      description: "Chaque professeur accède à ses classes et peut projeter le plan en cours.",
      image: "/eduplan-screens/daschboard prof.png"
    }
  ];

  return (
    <section className="py-24" data-testid="screenshots-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#FDF6E9] text-[#E7A541] rounded-full text-sm font-semibold tracking-wider uppercase mb-4">
            Aperçu de l'application
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-[#29282B] mb-4">
            Découvrez EduPlan en images
          </h2>
        </motion.div>

        <div className="space-y-20">
          {screenshots.map((screenshot, index) => (
            <motion.div 
              key={index}
              initial="hidden" 
              whileInView="visible" 
              viewport={{ once: true }} 
              variants={fadeUp}
              className={`flex flex-col ${index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-12`}
            >
              <div className="flex-1">
                <h3 className="font-display text-2xl font-bold text-[#29282B] mb-4">
                  {screenshot.title}
                </h3>
                <p className="text-[#29282B]/70 text-lg">
                  {screenshot.description}
                </p>
              </div>
              <div className="flex-1">
                <div className="rounded-xl overflow-hidden shadow-2xl border border-[#D9DADC]">
                  <img 
                    src={screenshot.image} 
                    alt={screenshot.title}
                    className="w-full h-auto"
                  />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductVisualSection;
